import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import companyService from '../services/company/company.service';

export const useCompanyData = () => {
  const { user, companyId: companyIdFromStore } = useSelector((state: RootState) => state.auth);
  const [companyData, setCompanyData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanyData = async () => {
    const id = (typeof user?.companyId === 'number' && !Number.isNaN(user.companyId))
      ? user.companyId
      : (companyIdFromStore && !Number.isNaN(Number(companyIdFromStore)) ? Number(companyIdFromStore) : undefined);
    if (!id) return;
    
    try {
      setLoading(true);
      setError(null);
      const company = await companyService.getCompanyById(id);
      setCompanyData(company);
    } catch (err: any) {
      setError(err.message || 'Company bilgileri alınamadı');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyData();
  }, [user?.companyId, companyIdFromStore]);

  return { companyData, loading, error, fetchCompanyData };
}; 